import React from 'react'
import PropTypes from 'prop-types'

import { useAuth } from './auth'
import { api } from '@shared/services/api'

const ConfigsContext = React.createContext({})

function useConfigs () {
  const context = React.useContext(ConfigsContext)

  if (!context) {
    throw new Error('useContext must be used within an ConfigsProvider')
  }

  return context
}

const ConfigsProvider = ({ children }) => {
  const [configs, setConfigs] = React.useState({})
  const [settings, setSettings] = React.useState({})
  const [isLoading, setIsLoading] = React.useState(true)

  const { user: isSigned } = useAuth()

  const getConfigs = React.useCallback(async () => {
    setIsLoading(true)
    const requests = []

    requests.push(
      api.get('/wholesaler/configs', { useCache: true }).then(({ data: content }) => {
        setConfigs(content)
      })
    )

    requests.push(
      api.get('/wholesaler/settings', { useCache: true }).then(({ data: content }) => {
        setSettings(content)
      })
    )

    Promise.all(requests).finally(() => {
      setIsLoading(false)
    })
  }, [])

  const refresh = React.useCallback(() => {
    if (!isLoading) {
      getConfigs()
    }
  }, [getConfigs, isLoading])

  React.useEffect(() => {
    if (isSigned) {
      getConfigs()
    }
  }, [isSigned, getConfigs])

  return (
    <ConfigsContext.Provider
      value={{
        configs,
        settings,
        isLoading,
        refresh
      }}>
      {children}
    </ConfigsContext.Provider>
  )
}

ConfigsProvider.propTypes = {
  children: PropTypes.any
}

export { useConfigs, ConfigsProvider }
